export const FIELD_ID = {
  case: {
    defendantDetail: {
      defendantType: 16368844,
    },
  },
}
